import * as AuthService from '../../services/auth';
import { showAlert } from './alert';
import { SITE_PROTOCOL, SITE_URL } from '../../config/environments';

const Types = {
  CSRF_TOKEN_SUCCESS: 'CSRF_TOKEN_SUCCESS',
  CSRF_TOKEN_ERROR: 'CSRF_TOKEN_ERROR',
  FETCH_LOGOUT: 'FETCH_LOGOUT',
  FETCH_AUTH_SUCCESS: 'FETCH_AUTH_SUCCESS',
  FETCH_AUTH_PENDING: 'FETCH_AUTH_PENDING',
  FETCH_AUTH_ERROR: 'FETCH_AUTH_ERROR',
  FETCH_USER_DATA_SUCCESS: 'FETCH_USER_DATA_SUCCESS',
  FETCH_USER_DATA_ERROR: 'FETCH_USER_DATA_ERROR',
  SET_IS_LOGGED: 'SET_IS_LOGGED',
  NO_USER_LOGGED_IN: 'NO_USER_LOGGED_IN',
};

const INITIAL_STATE = {
  user: {},
  csrf: AuthService.getCsrf() || null,
  userLoggedIn: false,
  role: null,
  isAdmin: false,
  fetched: false,
  error: null,
};

/** Methods */

/**
 * Get the CSRF token to handle all the request methods passing the X-CSRF-Token inside header
 */
export const getCsrf = () => {
  return async dispatch => {
    try {
      const { data } = await AuthService.requestCsrf();
      AuthService.setCsrf(data.csrf);
      dispatch(csrf_token_success(data.csrf));
    } catch (error) {
      console.log(error);
      dispatch(csrf_token_error());
    }
  };
};

/**
 * Handle the user status to set user logged in or not
 */
export const setIsLogged = status => {
  return { type: Types.SET_IS_LOGGED, payload: { status } };
};

/**
 * Test if passed token from user is valid
 */
export const testIfLoginTokenIsValid = token => {
  return async dispatch => {
    try {
      dispatch(fetch_auth_pending());
      const { data } = await AuthService.requestAuthValidationFromEmail(token);
      if (data.success) dispatch(getUserData());
    } catch (error) {
      if (!error.response) throw error;
      if (error.response.status === 403) dispatch(showAlert('error', 'You dont belong here 🔥'));
      if (error.response.status === 429) dispatch(showAlert('error', 'You have reached the attempt limit! Try later.'));
      dispatch(fetch_auth_error(error.response));
    }
  };
};

/**
 * Get user data from api
 */
export const getUserData = () => {
  return async dispatch => {
    try {
      const { data } = await AuthService.requestUserData();
      if (data.isAdmin) {
        dispatch(fetch_user_data_success(data));
        dispatch(fetch_auth_success());
        console.log('Login successfull!');
      } else {
        throw Error('UNAUTHORIZED');
      }
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', 'Ops! You are not an Admin! Get out of here! 🚔'));
      dispatch(fetch_auth_error(error.response));
      dispatch(fetch_user_data_error(error));
    }
  };
};

/**
 * Request api to logout and invalidate the 'kn' cookie
 */
export const logout = () => {
  return dispatch => {
    try {
      AuthService.logout();
      dispatch(fetch_logout_success());
    } catch (error) {
      console.log(error);
    }
  };
};

/**
 * If no user is logged in
 */
export const noUserLoggedIn = () => {
  return dispatch => {
    dispatch(no_user_logged_in());
  };
};

/** Actions */
const fetch_auth_success = () => {
  return { type: Types.FETCH_AUTH_SUCCESS };
};

const fetch_auth_pending = () => {
  return { type: Types.FETCH_AUTH_PENDING };
};

const fetch_auth_error = error => {
  return { type: Types.FETCH_AUTH_ERROR, error };
};

const fetch_logout_success = () => {
  return { type: Types.FETCH_LOGOUT };
};

const fetch_user_data_success = user => {
  return { type: Types.FETCH_USER_DATA_SUCCESS, payload: { user } };
};

const fetch_user_data_error = error => {
  return { type: Types.FETCH_USER_DATA_ERROR, error };
};

const csrf_token_success = csrf => {
  return { type: Types.CSRF_TOKEN_SUCCESS, payload: { csrf } };
};

const csrf_token_error = error => {
  return { type: Types.CSRF_TOKEN_ERROR, error };
};

const check_if_is_admin = () => {
  return { type: Types.CHECK_IF_IS_ADMIN };
};

const confirm_that_is_admin = () => {
  return { type: Types.CONFIRM_THAT_IS_ADMIN };
};

const no_user_logged_in = () => {
  return { type: Types.NO_USER_LOGGED_IN };
};

const auth = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.CSRF_TOKEN_ERROR:
      return { ...state, csrf: null, error: action.payload };
    case Types.CSRF_TOKEN_SUCCESS:
      return { ...state, csrf: action.payload.csrf };
    case Types.FETCH_AUTH_ERROR:
      return {
        ...state,
        fetched: true,
        userLoggedIn: false,
        user: {},
        role: null,
        isAdmin: false,
        userLoggedIn: false,
        error: action.payload,
      };
    case Types.FETCH_AUTH_SUCCESS:
      return { ...state, fetched: true, userLoggedIn: true };
    case Types.FETCH_USER_DATA_SUCCESS:
      return {
        ...state,
        fetched: true,
        userLoggedIn: true,
        isAdmin: action.payload.user.isAdmin,
        user: action.payload.user,
        role: action.payload.user.role,
      };
    case Types.FETCH_USER_DATA_ERROR:
      return {
        ...state,
        fetched: true,
        userLoggedIn: false,
        user: {},
        role: null,
        isAdmin: false,
        userLoggedIn: false,
        error: action.payload,
      };
    case Types.FETCH_LOGOUT:
      return {
        ...state,
        user: {},
        userLoggedIn: false,
        role: null,
        isAdmin: false,
        userLoggedIn: false,
        error: null,
      };
    case Types.SET_IS_LOGGED:
      return { ...state, userLoggedIn: action.payload.status };
    case Types.NO_USER_LOGGED_IN:
      return { ...state, fetched: true, userLoggedIn: false };
    default:
      return { ...state };
  }
};
export default auth;
